export default {
  namespaced: true,
  state: {
    results: [],
    resultFields: [],
    totalRowCount: 0,
    summaryArray: [],
    measuresInTable: [],
    sumVisible: false
  },
  getters: {
    getSummaryArray: state => {
      return state.summaryArray;
    },
    getMeasuresInTable: state => {
      return state.resultFields.filter(f => f.isMeasure);
    },
    getSumVisible: state => {
      return state.sumVisible;
    }
  },
  mutations: {
    updateResults(state, newResults) {
      if (newResults.data) {
        state.results = newResults.data;
      } else {
        state.results = [];
      }
    },
    updateResultFields(state, newResultField) {
      if (newResultField.length > 0) {
        state.resultFields = newResultField;
      } else {
        state.resultFields = [];
      }
    },
    select(state, rowNum) {
      state.results.forEach(element => {
        if (element.rowNum === rowNum) {
          element.valda = true;
        }
      });
    },
    deselect(state, rowNum) {
      state.results.forEach(element => {
        if (element.rowNum === rowNum) {
          element.valda = false;
        }
      });
    },
    selectAll(state) {
      state.results.map(a => (a.valda = true));
    },
    unselectAll(state) {
      state.results.map(a => (a.valda = false));
    },
    excludeSelectedRows(state) {
      state.results = state.results.filter(function(obj) {
        return obj.valda === false;
      });
    },
    updateRowCount(state, newRowcount) {
      state.totalRowCount = newRowcount;
    },
    setSummaryArray(state, value) {
      state.summaryArray = value
    },
    setMeasuresInTable(state, value) {
      state.measuresInTable = value
    },
    setSumVisible(state, value) {
      state.sumVisible = value
    }
  }
};
